module.exports = __webpack_public_path__ + "img/pc.946d7c86.png";